/* eslint-disable @typescript-eslint/no-use-before-define */

import React from 'react';

// Material UI
import Grid from '@material-ui/core/Grid';

// Constants
import IMAGES from 'constants/images';
import COLORS from 'constants/colors';

// Styles
import useStyles from './colorPicker.styles';

interface ColorPickerInterface {
  containerClass?: string;
  imageClass?: string;
  containerStyles?: React.CSSProperties;
  imageStyles?: React.CSSProperties;
  areaClass?: string;
  areaStyles?: React.CSSProperties;
  handleColor: (color: string) => void;
}

type Props = ColorPickerInterface;

const ColorPicker: React.FC<Props> = ({
  containerClass,
  imageClass,
  containerStyles,
  imageStyles,
  areaClass,
  areaStyles,
  handleColor,
}) => {
  const classes = useStyles();

  return (
    <Grid
      className={[classes.container, containerClass].join(' ')}
      style={containerStyles}>
      <img
        className={[classes.image, imageClass].join(' ')}
        style={imageStyles}
        src={IMAGES.COLOR_PICKER_IMAGE}
        alt='Color Picker Map'
        useMap='#colorPickerMap'
      />

      <map id='colorPickerMap' name='colorPickerMap'>
        {COLORS.map(({ coords, hex }) => (
          <area
            key={hex}
            className={[classes.area, areaClass].join(' ')}
            style={areaStyles}
            role='presentation'
            shape='poly'
            coords={coords}
            alt={hex}
            onClick={() => handleColor(hex)}
          />
        ))}
      </map>
    </Grid>
  );
};

export default ColorPicker;
export { ColorPicker };
